import React from "react";
import SummaryLineItem from "../events/event/cart/summary-line-item";
import { useDispatch, useSelector } from "react-redux";
import {
  selectPublicTournament,
} from "../../reducers/tournamentSlice";
import {
  addDonationToOrderThunk,
  removeDonationOrderItemThunk,
  selectCompletedOrder,
  selectRegistrationOrder,
} from "../../reducers/registrationOrderSlice";
import { moneyWithCommas } from "../../helpers/RegexHelper";
import { GSToggle } from "golfstatus_react_components";

const CheckoutRoundUpWidget = (props) => {
  const { complete } = props;
  const completedOrder = useSelector(selectCompletedOrder);
  const inProgressOrder = useSelector(selectRegistrationOrder);
  const registrationOrder = complete ? completedOrder : inProgressOrder;

  const roundUpDonationItems = registrationOrder?.donationOrderItems?.filter?.(
    (donation) => donation.roundUp
  );

  const roundUpEnabled = roundUpDonationItems?.length > 0

  const tournament = useSelector(selectPublicTournament);

  const dispatch = useDispatch();

  const toggleRoundUp = () => {
    if (roundUpEnabled) {
      dispatch(removeDonationOrderItemThunk(roundUpDonationItems[0]))
    }
    else {
      dispatch(addDonationToOrderThunk({amount: 0, roundUp: true, registrationOrder }))
    }
  };

  const roundUp = registrationOrder?.donationOrderItems?.find?.(
    (donation) => donation?.["roundUp"]
  )?.amount;

  return (
    <SummaryLineItem
      label="Round Up"
      description={`${tournament.name} will receive an extra donation, when you round up to the next whole dollar.`}
      value={roundUp ? moneyWithCommas(roundUp) : undefined}
      content={
        !complete ? (
          <GSToggle
            value={roundUpEnabled}
            trueDescription="Yes"
            falseDescription="No"
            onClick={() => {
              toggleRoundUp();
            }}
          />
        ) : null
      }
    />
  );
};

export default CheckoutRoundUpWidget;
